export default __webpack_public_path__ + "static/raceday-nft-1dd3bb766c14912d872a29a3ebdd793a.png";